<template>
    <div class="lb-project-nav-controls px-3 pt-4">
        <button
            v-if="!isTreasurehunt"
            v-t="'project.add_content'"
            :disabled="!hasCreationPermission"
            class="button is-pink-red has-shadow"
            @click="$emit('create')"
        />
        <button
            v-if="isTrivial"
            v-t="'project.showAnswers'"
            :disabled="!hasCreationPermission"
            class="button is-pink-red has-shadow ml-1"
            @click="$emit('showAnswers')"
        />
        <a
            v-if="hasMap"
            class="button is-pulled-right is-primary"
            @click="$emit('toggleMap')"
        >
            <span class="icon">
                <i
                    :class="
                        mapStatus
                            ? 'mdi-card-plus-outline'
                            : 'mdi-map-search-outline'
                    "
                    class="mdi mdi-18px"
                ></i>
            </span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        hasMap: {
            type: Boolean,
            default: false,
        },
        mapStatus: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        hasCreationPermission() {
            return this.$store.getters.project.accessLevel != 'read';
        },
        isTreasurehunt() {
            return this.$store.getters.project.type == 'treasurehunt';
        },
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
    },
};
</script>

<style scoped>
.lb-project-nav-controls {
    position: absolute;
    z-index: 29;
    width: 100%;
}
</style>
